import { Component } from 'react';

import ManualClusterSelect from '../../../components/manualClusterModal';
class ExtraButtons extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <div className="table-additional-view justify-content-between align-items-center">
                <div className="table-additional-view-btns justify-content-end">
                    <ManualClusterSelect
                        current_url={this.props.endpoint_url}
                        csrf_token={this.props.csrf_token}
                        selectedItems={this.props.selectedItems}
                        cluster_type="keyword"
                        header="Add To Keyword List"
                        onRemoveAllSelected={this.props.onRemoveAllSelected}
                    />
                </div>
            </div>
        );
    }
}

export default ExtraButtons;
